import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as IconMore } from "../Images/icon_more.svg";
import "../Styles/component.css";
import "../Styles/global.css";

const MORE_BTN_OPEN_EVENT = "dashboard-more-btn-open";

const MoreBtn = ({
  option1,
  option2,
  option1Addr,
  optionClickDelete,
  editingType,
  optionClickEdit = null,
  optionClickEditComplete = null,
}) => {
  const [isClicked, setIsClicked] = useState(false);
  const clickRef = useRef(null);
  const instanceIdRef = useRef(
    `more-btn-${Math.random().toString(36).slice(2)}`
  );
  const navigate = useNavigate();
  const hasOption1 = Boolean(option1);
  const hasOption2 = Boolean(option2);
  const longestOptionLength = Math.max(
    option1?.length ?? 0,
    option2?.length ?? 0
  );
  const popupStyle =
    longestOptionLength > 4
      ? { width: "100px", marginLeft: "-85px" }
      : longestOptionLength > 2
      ? { width: "81px", marginLeft: "-60px" }
      : {};
  const popupButtonStyle =
    longestOptionLength > 4
      ? { width: "100px" }
      : longestOptionLength > 2
      ? { width: "81px" }
      : {};

  const closeMenu = () => {
    setIsClicked(false);
  };

  const handleClick = () => {
    setIsClicked((prev) => {
      const next = !prev;
      if (next) {
        document.dispatchEvent(
          new CustomEvent(MORE_BTN_OPEN_EVENT, {
            detail: { id: instanceIdRef.current },
          })
        );
      }
      return next;
    });
  };
  const handleClickOutside = (e) => {
    if (clickRef.current && !clickRef.current.contains(e.target)) {
      closeMenu();
    }
  };
  const handleOpenOtherMenu = (e) => {
    if (e.detail?.id !== instanceIdRef.current) {
      closeMenu();
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener(MORE_BTN_OPEN_EVENT, handleOpenOtherMenu);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener(MORE_BTN_OPEN_EVENT, handleOpenOtherMenu);
    };
  }, []);

  const buttonStyle = {
    width: "40px",
    height: "40px",
    borderRadius: "8px",
    zIndex: 4,
    ...(isClicked ? { backgroundColor: "#f5f5f5" } : {}),
  };

  return (
    <div ref={clickRef}>
      <div className="center" style={buttonStyle} onClick={handleClick}>
        <IconMore />
      </div>
      {isClicked ? (
        <div
          className="editOrdelete_Box"
          style={popupStyle}
        >
          {hasOption1 && (
            <div
              className="editOrdelete_Btn edit center"
              style={popupButtonStyle}
              onClick={() => {
                editingType
                  ? optionClickEditComplete()
                  : optionClickEdit
                  ? optionClickEdit()
                  : navigate(option1Addr);
                closeMenu();
              }}
            >
              {option1}
            </div>
          )}
          {hasOption2 && (
            <div
              className="editOrdelete_Btn delete center"
              style={popupButtonStyle}
              onClick={() => {
                closeMenu();
                optionClickDelete();
              }}
            >
              {option2}
            </div>
          )}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default MoreBtn;
